import React from 'react';

export interface FaqPair {
  question: string;
  answer: string;
}

// Plain strings, because the same six pairs are the FAQPage JSON-LD on the homepage.
// Answers stand alone on purpose: each one has to survive being quoted without the page.
export const faqPairs: FaqPair[] = [
  {
    question: 'What does Kult.io do?',
    answer:
      'An AI engineering and AWS consultancy in Kraków, working with clients internationally. We design and build AI agents that use your tools, read your documents, and carry multi-step work to a finished result: an agent that acts, not a chatbot that answers. We also install AFK Development inside engineering teams. A second practice has run production AWS for over ten years.',
  },
  {
    question: 'What is AFK Development?',
    answer:
      'Away-from-keyboard development. Humans align on the spec and review the pull request; agents implement everything in between, through thin vertical slices, a feedback loop the agent cannot skip, a refactor pass of its own, and QA in a real browser. It runs in cloud development environments, not on a laptop. On one client engagement, throughput went up 70% with 85% of the code agent-generated.',
  },
  {
    question: 'What does the free assessment include?',
    answer:
      'Thirty minutes, no charge. Bring one process your team does by hand every week. You leave with whether an agent can finish it end to end, what building it would involve, and an honest no where that is the answer.',
  },
  {
    question: 'Do we need to be on AWS?',
    answer:
      'No. Agents run wherever your systems already are. AWS is a separate practice with its own clients and its own free infrastructure assessment.',
  },
  {
    question: 'Which models and tools do you build with?',
    answer:
      'We specialize in Anthropic Claude; the work is led by a Claude Certified Architect. Claude, Claude Code, MCP servers and Agent Skills, and the result is model-portable: Claude is the specialization, not a constraint you inherit.',
  },
  {
    question: 'How do you know an agent works before it goes live?',
    answer:
      'It is evaluated against your real cases before launch and ships with logging and alerting so drift is caught after. That habit comes from a decade of keeping other people’s production systems online.',
  },
];

const FaqSection = () => (
  <div id="faq" className="bg-gray-800 py-20">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-measure">
        <h2 className="font-display text-display-md font-bold text-white sm:text-display-lg">
          Questions we get
        </h2>
      </div>

      <dl className="mt-14 border-t border-gray-700">
        {faqPairs.map((pair) => (
          <div
            key={pair.question}
            className="grid gap-x-10 gap-y-3 border-b border-gray-700 py-8 lg:grid-cols-[1fr_2fr]"
          >
            <dt className="font-display text-display-sm font-medium text-white">{pair.question}</dt>
            <dd className="max-w-measure text-gray-300">{pair.answer}</dd>
          </div>
        ))}
      </dl>
    </div>
  </div>
);

export default FaqSection;
